import { supabase } from '../supabaseClient';

let currentUserId = null;

export function setLogUser(userId) {
  currentUserId = userId;
}

async function log(severity, component, action, details = {}) {
  if (process.env.NODE_ENV === 'development') {
    const fn = severity === 'error' ? console.error : severity === 'warn' ? console.warn : console.log;
    fn(`[${severity.toUpperCase()}] ${component}::${action}`, details);
  }
  try {
    await supabase.from('app_logs').insert({
      user_id: currentUserId,
      severity,
      component,
      action,
      details,
    });
  } catch (_) {
    // intentionally swallowed — logging must never crash the app
  }
}

export const logger = {
  info:  (component, action, details = {}) => log('info',  component, action, details),
  warn:  (component, action, details = {}) => log('warn',  component, action, details),
  error: (component, action, details = {}) => log('error', component, action, details),
};
